import axios from "axios";
const jsonConfig = require("../../Config.json");

const SearchReferralByRecruitmentPartnerId = async (data) => {
    let allResponse = {}
    try {
        const response = await axios.post(
            jsonConfig.apiUrl + "searchreferralByrecruitmentpartnerId/" + data.recruitmentPartnerId, data.data,
            {
              headers: {
                "x-functions-key": jsonConfig.key,
              }
            }
          );
        
        allResponse = response;

        return Promise.resolve(allResponse)
    }
    catch (error) {
      console.log("errrrrr", error);
        return Promise.reject(error)
    }
}

export default SearchReferralByRecruitmentPartnerId;